import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { RenderInputWithDiv } from '../../../component/formInput';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';


class UsernameModifyModal extends React.Component {

  constructor(props) {
    super(props);
  }

  submit = (values) => {
    const { onHide, userProduct, reset } = this.props;
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/service/change_username',
      data: {
        user_product_id: userProduct.id,
        new_username: values.username
      },
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        reset();
        onHide();
        toast.success("Cập nhật username dịch vụ thành công !");
      }
    })
  }
  

  handleHideModal = () => {
    const { onHide, reset } = this.props;
    reset();
    onHide();
  }

  render() {

    const { title, submitting, handleSubmit, userProduct } = this.props;
    const modalConfig = { enforceFocus: false, backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, submitting: this.props.submitting };
    return (
      <Modal
        bsPrefix = "modal"
        {...modalConfig}
        dialogClassName="modal-open">
          <ToastContainer />
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-sm">{title}</Modal.Title>
          </Modal.Header>
          <form onSubmit={handleSubmit(this.submit)}>
            <Modal.Body>
              <Field name="username" placeholder="Vui lòng nhập username mới..." component={RenderInputWithDiv}></Field>
            </Modal.Body>
            <Modal.Footer>
              <div className="text-right">
                <a className="btn" onClick={this.handleHideModal}>Đóng</a>
                <button type="submit" className="btn bg-primary" disabled={submitting}>Cập nhật</button>
              </div>
            </Modal.Footer>
          </form>
      </Modal>
    )
  }
}
const mapState = (state,props) => ({
  initialValues : {
    username: props.userProduct.username
  }
});

const mapDispatch = dispatch => ({

});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'UsernameModifyModal',
    destroyOnUnmount: true,
    enableReinitialize: true,
  })(withRouter(UsernameModifyModal))));
